import React, { ReactNode } from "react";
import { Flex, Text } from "@fluentui/react-northstar";
import { colorUtils } from "ecom-teams-apps-core";
import { Tag } from "shared/models/Tag";
import styles from "./tagLabel.module.scss";
import { constants } from "shared/constants";

interface TagLabelProps {
    tag: Tag;
    headerIcon?: ReactNode;
}

const prepareColor = (colorCode: string) => {
    return !colorCode.startsWith("#") && colorCode.length === 6 ? `#${colorCode}` : colorCode;
};

const TagLabel: React.FC<TagLabelProps> = (props: TagLabelProps) => {
    return (
        <div style={{ backgroundColor: prepareColor(props.tag.color) }} className={styles.label}>
            <Text
                color={
                    colorUtils.hasAppopriateContrast(props.tag.color, `#${constants.defaultTagColor}`)
                        ? "black"
                        : "white"
                }
                weight="semibold"
                size="smaller"
            >
                {props.tag.description.toUpperCase()}
            </Text>
        </div>
    );
};

export const ReversedTagLabel: React.FC<TagLabelProps> = (props: TagLabelProps) => {
    return (
        <div
            style={{
                backgroundColor: "transparent",
                borderColor: prepareColor(props.tag.color),
                borderWidth: "1px",
                borderStyle: "solid",
            }}
            className={styles.label}
        >
            <Flex vAlign="center" gap="gap.smaller" style={{ color: prepareColor(props.tag.color) }}>
                {props.headerIcon}
                <Text weight="semibold" size="smaller">
                    {props.tag.description.toUpperCase()}
                </Text>
            </Flex>
        </div>
    );
};

export default TagLabel;
